__turbopack_context__.v({
  "className": "barlow_condensed_71740f4a-module__mKpVqG__className",
  "variable": "barlow_condensed_71740f4a-module__mKpVqG__variable",
});
